import styled from 'styled-components';
import Text from '@stax-core/truffle-components/dist/Typography/Text';

export const PlaidText = styled(Text)`
  color: #bdc9cc;
  font-size: 28px;
  font-weight: normal;
  margin: 0;
  padding: 0;
`;
